<template>
  <div class="single-column">
    <section class="single-column__section">
      <h2 class="single-column__heading">アーティスト{{ isEdit ? '編集' : '登録' }}</h2>
      <div class="single-column__inner">
        <div class="profile-edit__head-text">
          <span>内容を確認してください。</span>
        </div>
        <div class="profile-info">
          <form>
            <div class="form-wrap form-wrap--profile u-no-margin-top">
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label">アーティスト名
                  </label>
                </div>
                <div class="form-item word-break">
                  {{ item.name_ja }}
                </div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label">アーティスト名（カナ表記）
                  </label>
                </div>
                <div class="form-item">
                  {{ item.name_kana }}
                </div>
              </div>
              <div class="form-group">
                <div class="form-label form-label--top">
                  <label
                    class="control-label">アーティスト名（アルファベット表記）
                  </label>
                </div>
                <div class="form-item word-break">
                  {{ item.name_en }}
                </div>
              </div>
              <div
                v-if="isBtoC"
                class="form-group">
                <div class="form-label">
                  <label
                    class="control-label">アーティストページ設定
                  </label>
                </div>
                <div class="form-item">
                  {{ item.is_narasu_displayed ? '表示' : '非表示' }}
                </div>
              </div>
              <div class="form-group">
                <div class="form-label form-label--top">
                  <label
                    class="control-label">プロフィール
                  </label>
                </div>
                <div class="form-item word-break wrap-text">
                  {{ item.profile_ja }}
                </div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label">オフィシャルサイト
                    <span>（URL）</span>
                  </label>
                </div>
                <div class="form-item">
                  <span class="pcmr5 spmr5">{{ item.url }}</span>
                </div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label">ブログ
                    <span>（URL）</span>
                  </label>
                </div>
                <div class="form-item">
                  <span class="pcmr5 spmr5">{{ item.blog }}</span>
                </div>
              </div>

              <div
                v-for="(social) in socials"
                :key="social.type"
                class="form-group js-tooltip">
                <div class="form-label">
                  <label
                    class="control-label">{{ social.title }}
                    <span
                      v-if="social.note">
                      {{ social.note }}</span>
                  </label>
                </div>
                <div class="form-item">
                  <span class="pcmr5 spmr5">{{ item.socials[`${social.type}`] }}</span>
                </div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label class="control-label">アーティスト写真</label>
                </div>
                <div class="form-item">
                  <img
                    v-if="image"
                    style="max-width: 320px"
                    :src="image">
                </div>
              </div>
              <div
                v-if="!isBtoC"
                class="form-group">
                <div class="form-label">
                  <label class="control-label">Spotify用 カバー写真</label>
                </div>
                <div class="form-item">
                  <img
                    v-if="spotifyImage"
                    style="max-width: 320px"
                    :src="spotifyImage">
                </div>
              </div>
              <div
                v-if="!isBtoC"
                class="form-group">
                <div class="form-label">
                  <label
                    class="control-label">公開希望日
                  </label>
                </div>
                <div class="form-item">
                  <span class="pcmr5 spmr5">{{ item.publish_date }}</span>
                </div>
              </div>
            </div>
            <div class="c-btn-wrap">
              <a
                href="#"
                class="c-btn c-btn--back"
                @click.prevent="onReturnClicked">
                <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
                戻る
              </a>
              <a
                href="#"
                class="c-btn"
                @click.prevent="onSaveClicked">
                保存
                <span class="c-btn__icon-arrow"></span>
              </a>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ArtistConfirm',
  props: {
    item: {
      type: Object,
      required: true,
    },
    image: {
      type: String,
      require: false,
      default: null,
    },
    spotifyImage: {
      type: String,
      require: false,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    socials: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      genres: [],
    }
  },
  computed: {
    profileJa() {
      return this.item.profile_ja
        ? this.item.profile_ja.replace(/\n/g, '<br/>')
        : ''
    },
  },
  mounted() {
    this.fetchGenres()
  },
  methods: {
    async fetchGenres() {
      const response = await window.axios.get('/api/client/genres')
      this.genres = response.data
    },
    onReturnClicked() {
      this.$emit('return-clicked')
    },
    onSaveClicked() {
      this.$emit('save-clicked')
    },
  },
}
</script>

<style scoped>
.form-item-member__wrap {
  display: block;
}
.word-break {
  word-break: break-all;
}
.wrap-text {
  white-space: pre-line;
  word-break: break-all;
}
</style>
